import { CandidateSpecialty } from 'src/app/recruiting/locums-margin-calculator/models/candidate-details.model';
import { ProfessionExpertise } from '../../models/profession-expertise.model';

export interface CandidateDetailsSlice {
    readonly candidateId: number;
    readonly candidateName: string;
    readonly candidateEmail: string;
    readonly candidateNPI: number;
    readonly professionId: number;
    readonly professionName: string;
    readonly specialties: CandidateSpecialty[];
    readonly professionExpertises: ProfessionExpertise[];
    readonly candidateExpertiseId: number;
    readonly expertiseId: number;
    readonly expertiseYearsOfExperience: number;
    readonly providerProfile: string;
    readonly recruiterId: number;
    readonly recruiterName: string;
}

export const initialCandidateDetailsSlice: CandidateDetailsSlice = {
    candidateId: 0,
    candidateName: '',
    candidateEmail: '',
    candidateNPI: 0,
    professionId: 0,
    professionName: '',
    specialties: [],
    professionExpertises: [],
    candidateExpertiseId: 0,
    expertiseId: 0,
    expertiseYearsOfExperience: 0,
    providerProfile: '',
    recruiterId: 0,
    recruiterName: ''
};
